import { Engine, Slip } from '../src/slip-lib'


MathJax.startup.promise.then(() => {
    let engine = new Engine(document.querySelector("#rootSlip"));
    window.engine = engine;
    let rootSlip = engine.getRootSlip();
    // let rootSlip = new Slip("rootSlip", [], engine, {});
    engine.setRootSlip(rootSlip);
    //rootSlip.setEngine(engine);
    let intro = new Slip("calcul", "Introduction to Computability Theory", [], engine, {
	init: (slip) =>
	    {
		turingMachine1 = new TuringMachine(transitionTable1, 0, 3);
		turingMachine1.setMemory([0,1,0,1,1,0]);
	    }});
    intro.setAction([
	// }, (slide, engine, presentation) => {
	// }, (slide, engine, presentation) => {
	(slide, engine, presentation) => {
	    slide.cv = slide.query("#canvas-tm1");
	    drawGraph1(100, 500, 300, 700, 25, null, "0", slide.cv);
	    drawMem(["","","","","",""], 250,600, 0, slide.cv);
	    // slide.query(".f-calc").style.opacity = "1";
	}, (slide, engine, presentation) => {
	    slide.query(".input").classList.add("putted");
	}, (slide, engine, presentation) => {
	    slide.getEngine().moveToElement(slide.query("#computer"), {});
	    // slide.getEngine().moveWindowRelative(0,0.15,-0.3,0,1);
	    drawTuringMachine1(turingMachine1, 500,  () => {
	        slide.query(".output").style.opacity= "1";	    
	    });
	}, (slide, engine, presentation) => {
	    slide.query(".output").classList.add("putted");
	    // slide.getEngine().moveToElement(slide.element, {});
	    slide.getEngine().moveWindow(slide.currentX,slide.currentY,1,0,1);
	}, (slide, engine, presentation) => {
	}, (slide, engine, presentation) => {
	    // slide.query(".f-calc").style.opacity = "0";
	    slide.query(".output").style.display = "none";
	    // slide.query(".recursif").style.opacity = "1";
	    slide.query(".input").classList.toggle("movable");
	    slide.query(".input").classList.toggle("putted");
	}, (slide, engine, presentation) => {
	    turingMachine1.setPointer(0);
	    turingMachine1.setState(0);
	    turingMachine1.setMemory([0,1,0,1,1,0]);
	    setTimeout(() => {	// slide.query(".appartenance").style.opacity = "1";
	        drawTuringMachine1(turingMachine1, 50,  () => {
	    	slide.query(".appartenance").classList.toggle("putted");
	        });
	    }, 1000);
	    slide.query(".input").classList.toggle("movable");
	    slide.query(".input").classList.toggle("putted");	
	// }, (slide, engine, presentation) => {
	//     // slide.query(".recursif").style.opacity = "0";
	//     // slide.query(".r-e").style.opacity = "1";
	//     slide.query(".input").style.opacity = "0";
	//     slide.query(".appartenance").style.display="none";
	//     // }, (slide, engine, presentation) => {
	//     slide.stop = 0 
	//     let step = () => {turingMachine1.setPointer(0);turingMachine1.setState(0);turingMachine1.setMemory([0,1,0,1,1,0]);
	// 		      drawTuringMachine1(turingMachine1, 150,  () => {
	// 			  slide.query(".entier").style.transition = "";
	// 			  slide.query(".entier").classList.remove("movable");
	// 			  setTimeout(() => {
	// 			      slide.query(".entier").classList.remove("putted");
	// 			      setTimeout(() => {
	// 				  slide.query(".entier").innerHTML = Math.floor(Math.random()*1000);
	// 				  slide.query(".entier").style.transition = "left 1s, right 1s";
	// 				  slide.query(".entier").classList.add("putted");
	// 			      }, 100);
	// 			  }, 100);
	// 			  if(!slide.stop)
	// 			      step();
	// 		      }, "notblue");
	// 		     };
	//     step();
	    // }, (slide, engine, presentation) => {
	    // 	this.stop = 1;
	    // setTimeout(() => {
	    //     slide.queryAll(".entier")[0].classList.toggle("putted");
	    // }, 1000);
	    // setTimeout(() => {
	    //     slide.queryAll(".entier")[1].classList.toggle("putted");
	    // }, 2000);
	    // setTimeout(() => {
	    //     slide.queryAll(".entier")[2].classList.toggle("putted");
	    // }, 4000);
	    // setTimeout(() => {
	    //     slide.queryAll(".entier")[3].classList.toggle("putted");
	    // }, 5000);
	},

    ]) 
    window.introD = intro;
    let rm = new Slip("rm", "Reverse Mathematics", [], engine, {});
    // let htOld = new Slip("ht", "Hindman's Theorem", [], engine, {});


    let ht = new Slip("ht", "Hindman's Theorem", [
	(slide, engine, presentation) => {
	}, (slide, engine, presentation) => {
	}, (slide, engine, presentation) => {
	}, (slide, engine, presentation) => {
	}, (slide, engine, presentation) => {
	}, (slide, engine, presentation) => {
	}, (slide, engine, presentation) => {
	}, (slide, engine, presentation) => {
	}, (slide, engine, presentation) => {
	}, (slide, engine, presentation) => {
	}, (slide, engine, presentation) => {
	}, (slide, engine, presentation) => {
	}, (slide, engine, presentation) => {
	}, (slide, engine, presentation) => {
	    slide.query(".c1").style.opacity = "1";
	}, (slide, engine, presentation) => {
	    slide.d1 = (slide.query(".c2").offsetTop+slide.query(".c2").offsetHeight)/1080 -1 +0.0125;
	    // engine.moveWindowRelative(0,slide.d1,0,0,1);
	    // slide.querySelector(".large-infinite").addEventListener
	    slide.coloriage = [];
	    for(let i=0; i<1000; i++)
		slide.coloriage.push(["red", "blue"][i%2]);
	    slide.setH = new Set();
	    // slide.coloriage[0] = "blue";
	    slide.refresh();
	    // slide.query(".c2").style.opacity = "1";
	    // slide.query(".large-infini").classList.add("emphasize");
	}, (slide, engine, presentation) => {
	    // slide.query(".large-infini").classList.remove("emphasize");
	    // slide.query(".large-infini").classList.add("barre");
	    // slide.query(".large-hindman").classList.add("emphasize");
	    // slide.query(".c3").style.opacity = "1";
	}, (slide, engine, presentation) => {
	    // slide.query(".large-hindman").classList.remove("emphasize");
	    // slide.query(".large-hindman").classList.add("barre");
	    // slide.query(".large-baumgartner").classList.add("emphasize");
	    // slide.query(".large-ultrafilter").classList.add("emphasize");
	    // slide.query(".c4").style.opacity = "1";
	    // slide.query(".c5").style.opacity = "1";
	}, (slide, engine, presentation) => {
	    // slide.d2 = (slide.query(".c1").offsetTop)/1080 -0.0125 - slide.d1;
	    // engine.moveWindowRelative(0,slide.d2,0,0,1);
	}, (slide, engine, presentation) => {
	    // slide.query(".c6").style.opacity = "1";
	}, (slide, engine, presentation) => {
	}, (slide, engine, presentation) => {
	    slide.coloriage = [];
	    slide.setF = new Set();
	    slide.setH = new Set();
	    // slide.moveDownTo(".fm-def", 1, -0.1);
	    // slide.d3 = (slide.query(".fm-def").offsetTop+410)/1080 -1 - slide.d2 -slide.d1;
	    // engine.moveWindowRelative(0,slide.d3,0,0,1);
	    // slide.kept = [];
	    for(let i=0; i<1000; i++) {
		slide.coloriage.push(["red", "blue"][Math.floor(Math.random()*1.999)]);

	    }
	    slide.queryAll(".number-container.clone").forEach((nContainer) => {
		slide.populate(60, nContainer);
		let dots = document.createElement("div");
		dots.classList.add("number","suspension");
		dots.innerText = "...";
		nContainer.appendChild(dots);
		slide.refresh();
	    });
	    function refresh() {
		slide.queryAll(".number-container.clone .number").forEach((number, index) => {
		    number.classList.remove("selected2", "candidate", "removed");
		    if(slide.setF.has(index))
			number.classList.add("selected2");
		    else if (typeof (Array.from(slide.setF).find((n) => { return checkGood([n], index, slide.coloriage);})) == "undefined")
			number.classList.add("removed");
		});
	    }
	    slide.refresh2 = refresh;
	    slide.queryAll(".number-container.clone .number").forEach((number, index) => {
		number.addEventListener("click", (ev) => {
		    if (slide.setF.has(index)) {
			slide.setF.delete(index);
		    }
		    else {
			slide.setF.add(index);
		    }
		    console.log("slide.setF",slide.setF);
		    refresh();
		});
	    });
	    refresh();
	}, (slide, engine, presentation) => {
	    let setFArray = Array.from(slide.setF);
	    console.log("setFArray",setFArray, setFArray[0], setFArray[1]);
	    let a0 = (typeof setFArray[0] != "undefined") ? setFArray[0] : 1;
	    let a1 = (typeof setFArray[1] != "undefined") ? setFArray[1] :  ((a0==1) ? 2 : 1);
	    slide.setF.add(a0);
	    slide.setF.add(a1);
	    slide.refresh2();
	    // let a1 = setFArray[1] || ((a0==1) ? 2 : 1);
	    console.log(a0, a1);
	    slide.queryAll(".number-container.clone .number").forEach((number, index) => {
		// number.classList.remove("selected", "candidate", "removed");
		if(index == a0) {
		    number.classList.add("left");
		}
		if(index == a1) {
		    number.classList.add("right");
		}
		else if (checkGood([a0], index, slide.coloriage))
		    number.classList.add("left");
		else if (checkGood([a1], index, slide.coloriage))
		    number.classList.add("right");
	    });
	    slide.queryAll(".number-container.clone .suspension")[0].classList.remove("removed", "left", "right");
	    slide.queryAll(".number-container.clone .suspension")[0].classList.add("right");
	    slide.queryAll(".number-container.clone .suspension")[1].classList.remove("removed", "left", "right");
	    slide.queryAll(".number-container.clone .suspension")[1].classList.add("left");
	    // slide.queryAll(".number-container.clone .number").forEach((number) => {
	    //     number.classList.add(["left", "right", "removed"][Math.floor(Math.random()*2.999)]);
	    // });
	}, (slide, engine, presentation) => {
	    slide.d4 = (slide.query(".tree-canvas").offsetTop+slide.query(".tree-canvas").offsetHeight-30)/1080 -1 -(slide.d1 + slide.d2 + slide.d3);
	    // engine.moveWindowRelative(0,slide.d4,0,0,1);
	}, (slide, engine, presentation) => {
	    slide.treeCanvas = slide.query(".tree-canvas");
	    slide.treeCtx = slide.treeCanvas.getContext("2d");
	    slide.treeCtx.font= "30px Arial";
	    // slide.treeCtx.font = "30px Arial";
	    slide.p0 = {x:500, y:100-80};
	    slide.p1 = {x:300, y:200-80};
	    slide.p2 = {x:700, y:200-80};
	    slide.p3 = {x:600, y:300-80};
	    slide.p4 = {x:700, y:300-80};
	    slide.p5 = {x:800, y:300-80};
	    slide.p6 = {x:300, y:300-80};
	    slide.p7 = {x:700, y:400-80};
	    slide.p8 = {x:800, y:400-80};
	    slide.p9 = {x:900, y:400-80};
	    slide.p10 = {x:700, y:500-80};
	    slide.p11 = {x:800, y:500-80};
	    slide.p12 = {x:900, y:500-80};
	    slide.treeCtx.fillText("Full-Match", 1000, 200-80);
	    slide.treeCtx.fillText("S_0", 100, 200-80);
	    drawNode(slide.p0, 10, slide.treeCanvas, "", "black");
	    drawNode(slide.p1, 10, slide.treeCanvas, "", "black");
	    drawNode(slide.p2, 10, slide.treeCanvas, "", "black");
	    myQuadraticCurveArrowHeads(slide.p0, 0, 0, slide.p1, 15, 15, false, true, slide.treeCtx, "black");
	    myQuadraticCurveArrowHeads(slide.p0, 0, 0, slide.p2, 15, 15, false, true, slide.treeCtx, "black");
	}, (slide, engine, presentation) => {
	    drawNode(slide.p3, 10, slide.treeCanvas, "", "black");
	    drawNode(slide.p4, 10, slide.treeCanvas, "", "black");
	    drawNode(slide.p5, 10, slide.treeCanvas, "", "black");
	    drawNode(slide.p6, 10, slide.treeCanvas, "", "black");
	    slide.treeCtx.fillText("S_1", 100, 300-80);
	    slide.treeCtx.fillText("Full-Match", 1000, 300-80);
	    myQuadraticCurveArrowHeads(slide.p2, 0, 0, slide.p3, 15, 15, false, true, slide.treeCtx, "black");
	    myQuadraticCurveArrowHeads(slide.p2, 0, 0, slide.p4, 15, 15, false, true, slide.treeCtx, "black");
	    myQuadraticCurveArrowHeads(slide.p2, 0, 0, slide.p5, 15, 15, false, true, slide.treeCtx, "black");
	    myQuadraticCurveArrowHeads(slide.p1, 0, 0, slide.p6, 15, 15, false, true, slide.treeCtx, "black");
	}, (slide, engine, presentation) => {
	    drawNode(slide.p7, 10, slide.treeCanvas, "", "black");
	    drawNode(slide.p8, 10, slide.treeCanvas, "", "black");
	    drawNode(slide.p9, 10, slide.treeCanvas, "", "black");
	    slide.treeCtx.fillText("S_2", 100, 400-80);
	    slide.treeCtx.fillText("Full-Match", 1000, 400-80);
	    myQuadraticCurveArrowHeads(slide.p4, 0, 0, slide.p7, 15, 15, false, true, slide.treeCtx, "black");
	    slide.treeCtx.fillText("S_3", 100, 500-80);
	    slide.treeCtx.fillText("Full-Match", 1000, 500-80);
	    myQuadraticCurveArrowHeads(slide.p5, 0, 0, slide.p8, 15, 15, false, true, slide.treeCtx, "black");
	    myQuadraticCurveArrowHeads(slide.p5, 0, 0, slide.p9, 15, 15, false, true, slide.treeCtx, "black");
	    slide.treeCtx.setLineDash([5]);
	    myQuadraticCurveArrowHeads(slide.p7, 0, 0, slide.p10, 15, 15, false, false, slide.treeCtx, "black");
	    // myQuadraticCurveArrowHeads(slide.p8, 0, 0, slide.p11, 15, 15, false, false, slide.treeCtx, "black");
	    myQuadraticCurveArrowHeads(slide.p9, 0, 0, slide.p12, 15, 15, false, false, slide.treeCtx, "black");
	}, (slide, engine, presentation) => {
	    slide.treeCtx.setLineDash([0]);
	    slide.treeCtx.lineWidth = 3;
	    myQuadraticCurveArrowHeads(slide.p0, 0, 0, slide.p2, 15, 15, false, true, slide.treeCtx, "red");
	    myQuadraticCurveArrowHeads(slide.p2, 0, 0, slide.p4, 15, 15, false, true, slide.treeCtx, "red");
	    myQuadraticCurveArrowHeads(slide.p4, 0, 0, slide.p7, 15, 15, false, true, slide.treeCtx, "red");
	    slide.treeCtx.setLineDash([5]);
	    myQuadraticCurveArrowHeads(slide.p7, 0, 0, slide.p10, 15, 15, false, false, slide.treeCtx, "red");
	}, (slide, engine, presentation) => {
	    slide.d5 = (slide.query(".conclusion").offsetTop)/1080 -(slide.d1+slide.d2+slide.d3+slide.d4)-0.0125;
	    // engine.moveWindowRelative(0,slide.d5,0,0,1);
	}, (slide, engine, presentation) => {
	    slide.query(".c7").style.opacity = "1";
	}, (slide, engine, presentation) => {
	    slide.query(".c8").style.opacity = "1";
	}, (slide, engine, presentation) => {
	    slide.d6 = (slide.query(".c9").offsetHeight+slide.query(".c9").offsetTop)/1080 -(slide.d1+slide.d2+slide.d3+slide.d4+slide.d5)+0.0125;
	    slide.query(".c9").style.opacity = "1";
	    // engine.moveWindowRelative(0,0.07,0,0,1);
	}], engine, {init: (slide, engine, presentation) => {
	slide.nNumber = 150;
	slide.populate = (nNumber, nContainer) => {
	    for(let i=0; i<nNumber; i++) {
		let elem = document.createElement("div");
		elem.classList.add("n"+i);
		elem.classList.add("number");
		elem.innerText = i;
		nContainer.appendChild(elem);
	    }
	    let dots = document.createElement("div");
	    dots.classList.add("number","suspension");
	    dots.innerText = "...";
	    nContainer.appendChild(dots);
	};
	slide.populate(slide.nNumber, slide.query(".number-container"));
	slide.coloriage = [];
	slide.setH = new Set();
	// slide.kept = [];
	for(let i=0; i<1000; i++) {
	    slide.coloriage.push(["red", "blue"][Math.floor(Math.random()*1.999)]);
	    // slide.kept.push(1);
	}
	refresh();
	slide.query(".refresh").addEventListener("click", (ev) => {
	    slide.coloriage = [];
	    slide.setH = new Set();
	    // slide.kept = [];
	    for(let i=0; i<1000; i++) {
		slide.coloriage.push(["red", "blue"][Math.floor(Math.random()*1.999)]);
		// slide.kept.push(1);
	    }
	    refresh();
	});
	slide.setH = new Set();
	slide.queryAll(".number-container.original .number").forEach((elem, index) => {
	    elem.addEventListener("click", (ev) => {
		if(slide.setH.has(index))
		    slide.setH.delete(index);
		else if(checkGood(Array.from(slide.setH), index, slide.coloriage))
		    slide.setH.add(index);
		console.log(slide.setH);
		refresh();
	    });
	});
	function refresh() {
	    for(let i=0;i<slide.nNumber;i++) {
		slide.queryAll(".number-container .n"+i).forEach((number) => {
		    number.style.color = slide.coloriage[i];
		    if(slide.setH.has(i)) {
			number.classList.add("selected");
			number.classList.remove("removed");
		    }
		    else if(checkGood(Array.from(slide.setH), i, slide.coloriage)) {
			number.classList.remove("selected");
			number.classList.remove("removed");
		    }
		    else {
			number.classList.remove("selected");
			number.classList.add("removed");		
		    }
		});
	    }
	}
	slide.refresh = refresh;
    }});

    function checkGood(debH, n, coloring) {
	// console.log(debH, n, coloring);
	if(debH.length == 0)
	    return true;
	let a = debH[0];
	if(coloring[a] != coloring[n] || coloring[n+a] != coloring[n] || coloring[a] != coloring[n+a])
	    return false;
	return((checkGood(debH.slice(1), n, coloring)) && checkGood(debH.slice(1), n+a, coloring));
    }
    
    // We want a fine control, so we don't let the presentation order the slips by their order of appearance in the HTML file.
    // (slide is mostly because we want the slips "red" and "blue" in the middle of the slip "future")

    // Creation of slips

    rootSlip.setAction([
	(slip) => {
	    slip.getEngine().moveWindowRelative(0,0,0,90,1);
	}, (slip) => {
	    // slip.getEngine().moveWindowRelative(0,0,0,-90,1);
	    // setTimeout(() => {slip.getEngine().next();}, 200);
	},
	intro,
	() => {},
	rm,
	() => {},
	ht,
	() => {},
	//     base,
	//     beamerPart,
	//     future,
	//     // scaleTest,
	//     // blue,
	//     //    future, // coming back to the unfinished "future"
	//     //    links,
	//     // (slip) => {
	
	//     // }
    ]);
    // presentation.setSlips([
    //     intro,
    //     base,
    //     beamerPart,
    //     future,
    //     // scaleTest,
    //     blue,
    //     future, // coming back to the unfinished "future"
    //     links,
    // ]);
    let controller = new Controller(engine);
});
